import Layout from '@/views/Layout';

// 代理商报表
export default {
  name: 'AgentReport',
  path: '/agent-report',
  meta: {
    icon: 'el-icon-document',
    label: '代理商报表',
    isMenu: true,
  },
  component: Layout,
  children: [
    {
      name: 'AgentReportConsumptionStatistics',
      path: 'consumption-statistics',
      meta: {
        label: '代理商消耗统计',
        isMenu: true,
      },
      component: () =>
        import('@/views/AgentReport/ConsumptionStatistics/Index'),
    },
    {
      name: 'AgentReportConsumptionTrend',
      path: 'consumption-trend',
      meta: {
        label: '代理商消耗趋势',
        isMenu: true,
      },
      component: () => import('@/views/AgentReport/ConsumptionTrend/Index'),
    },
    {
      name: 'AgentReportDataView',
      path: 'data-view',
      meta: {
        label: '大盘详情',
        isMenu: true,
      },
      component: () => import('@/views/AgentReport/DataView/Index'),
    },
  ],
};
